/**
 * AddDeviceCtrl controller
 * Add/edit device
 */

import { GET_TIMEZONES } from 'app/core/constants'
import { getId, indexIn } from 'app/helpers/entity'

// controller mixins
AddDeviceCtrl.mixes = [{
  m2mCtrlMixin: [
    'device', // entity with m2m field
    'networks', // entity field
    undefined, // vm field (same as entity above)
    function () { // callback, for multiple devices, subscriber networks
      this.updateSubscriberNetworks() // eslint-disable-line no-invalid-this
    }
  ]
}]

/**
 * AddDeviceCtrl controller
 *
 * @class AddDeviceCtrl
 * @memberof mwApp/devices
 * @see mwApp/devices
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/devices.controller:AddDeviceCtrl
 */
/* @ngInject */
export default function AddDeviceCtrl ($scope, $location, alertSvc, Device, Network, device, authSvc) {
  var vm = this
  vm.device = device
  vm.isNew = device._isNew()
  vm.webPlatformEnabled = authSvc.hasEnabledFlag('WEB_PLATFORM_ENABLED')

  if (!vm.isNew && device.networks.length === 0) {
    vm.networkSelected = { id: 0, name: 'All Organizations' }
  }

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  // timezones
  GET_TIMEZONES().to(vm.timezones = [])

  // device redirect extensions
  vm.rext = !!device.deviceRedirectExtension
  if (vm.webPlatformEnabled && vm.device.platformType === 'WEB') {
    vm.rext = false
  }
  var originalDeviceRedirectExtension = device.deviceRedirectExtension // save device redirect extensions in order to check it later

  /**
   * Checkbox if device identifier is autogenerated
   *
   * @memberof mwApp/devices.controller:AddDeviceCtrl
   * @type {Boolean}
   */
  vm.autoIdentifier = vm.isNew

  /**
   * Checkbox if device Security Code is autogenerated
   *
   * @memberof mwApp/devices.controller:AddDeviceCtrl
   * @type {Boolean}
   */
  vm.autoSecurityCode = false

  // load networks and themes for device from server
  vm.subscriberNetworks = []
  Device.loadExtra(Device.extraFor(device))
    .then(
      extra => {
        vm.extra = extra
        vm.subscriberNetworks = extra.networks
        device.theme = device.theme || vm.extra.themes[0]

        // TODO remove when backend will refactor redirect extensions
        if (extra.deviceRedirects && extra.deviceRedirects.length) {
          extra.deviceRedirects.forEach(e => { e.extensionType = 'Device_Redirect' })
        }
        const existingNetworks = vm.device.networks.map(getId)
        vm.networks = [{ id: 0, name: 'All Organizations' }].concat(extra.networks.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)))
          .filter(n => existingNetworks.indexOf(n.id) === -1)
        $scope.loading = false
      }
    )

  vm.updateSubscriberNetworks = function () {
    if (device.networks.length > 0) {
      vm.subscriberNetworks = device.networks
      if (vm.subscriberNetwork && indexIn(vm.subscriberNetworks)(vm.subscriberNetwork) === -1) {
        vm.subscriberNetwork = null
      }
    } else {
      vm.subscriberNetworks = vm.extra.networks
    }
  }

  /**
   * Save device
   *
   * @memberof mwApp/devices.controller:AddDeviceCtrl
   */
  vm.saveDevice = function () {
    function doSave () {
      vm.setDisable()

      device._save(
        device => {
          device.deviceRedirectExtension = vm.rext ? device.deviceRedirectExtension : null
          device.identifier = vm.autoIdentifier ? null : device.identifier
          device.securityCode = vm.autoSecurityCode ? null : device.securityCode
        }
      ).then(vm.location(device).reload)
        .finally(vm.unsetDisable)
    }

    if (!vm.isNew && !originalDeviceRedirectExtension && vm.rext && !!device.subscriber) {
      alertSvc.confirm('You\'ve checked "Device Redirect" - device will be unassigned from subscriber. Are you sure?')
        .then(doSave)
    } else {
      doSave()
    }
  }

  /**
   * Delete device
   *
   * @memberof mwApp/devices.controller:AddDeviceCtrl
   */
  vm.deleteDevice = function () {
    vm.setDisable()

    device._delete()
      .then(vm.location(device).list)
      .finally(vm.unsetDisable)
  }

  /**
   *  Filter networkSets according available networks
   * @param pckg
   * @returns {Function}
   */
  vm.deselectPckg = function (pckg) {
    vm.deselectNetwork(pckg)
    vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.networks.filter(n => n.id !== 0).sort((a, b) => {
      return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
    }))
  }

  vm.selectOrganization = function () {
    if (vm.networkSelected.id !== 0) {
      vm.selectNetwork(vm.networkSelected)
      vm.networkSelected = null
    } else {
      const networks = angular.copy(vm.device.networks)
      networks.forEach(network => {
        vm.deselectPckg(network)
      })
    }
  }

  /**
   * Reset device's IP
   *
   * @memberof mwApp/devices.controller:AddDeviceCtrl
   */
  vm.resetIP = function () {
    device._resetIp()
  }

  /* === Multiple devices === */

  vm.devices = [{}, {}, {}, {}]

  vm.deviceRedirectExtension = null

  vm.file = {
    file: null,
    serialFirst: true,
    separator: '/s'
  }

  /**
   * Save multiple devices
   */
  vm.saveDevices = function () {
    vm.setDisable()
    var devices = []
    var dev

    if (vm.rext) {
      vm.createSubscriber = null
      vm.subscriberNetwork = null
    }

    for (var i = vm.devices.length; i--;) {
      if (vm.devices[i].serialNumber && vm.devices[i].macAddress) {
        dev = new Device(device)
        dev.macAddress = vm.devices[i].macAddress
        dev.serialNumber = vm.devices[i].serialNumber
        dev.deviceRedirectExtension = vm.rext ? vm.deviceRedirectExtension : null
        devices.push(dev)
      }
    }

    // save devices
    Device.saveAll(devices, !!vm.createSubscriber, vm.subscriberNetwork ? vm.subscriberNetwork.id : undefined)
      .then(
        response => {
          var result = response.data
          var success = 0
          var fail = 0

          var devices = []
          for (var i = 0; i < vm.devices.length; i++) {
            if (vm.devices[i].serialNumber && vm.devices[i].macAddress) {
              if (Object.prototype.hasOwnProperty.call(result, vm.devices[i].serialNumber)) {
                fail++
                vm.devices[i].error = result[vm.devices[i].serialNumber]
                devices.push(vm.devices[i])
              } else {
                success++
              }
            }
          }

          vm.setDisable()

          if (success === 0) {
            alertSvc.alert('0 devices added', 'danger')
            return
          }

          if (fail === 0) {
            alertSvc.alert('All devices successfully added', 'success')
          } else {
            alertSvc.alert(success + ' devices successfully added<br>' + fail + ' devices failed', 'info')
          }

          while (devices.length < 4) {
            devices.push({})
          }
          vm.devices = devices
        }
      ).finally(vm.unsetDisable)
  }

  /**
   * Remove device from list
   * @param  {Object} dev - device
   */
  vm.deleteDevices = function (dev) {
    for (var i = vm.devices.length; i--;) {
      if (vm.devices[i] === dev) {
        vm.devices.splice(i, 1)
        break
      }
    }
  }

  /**
   * Count filled devices
   * @return {Number}
   */
  vm.devicesCount = function () {
    var ret = 0

    for (let i = vm.devices.length; i--;) {
      if (vm.devices[i].serialNumber && vm.devices[i].macAddress) {
        ret++
      }
    }

    while (vm.devices.length < ret + 1) {
      vm.devices.push({})
    }

    return ret
  }

  /**
   * Load and show file content
   */
  vm.viewFileCont = function () {
    if (vm.file.file) {
      var reader = new window.FileReader()

      reader.onload = function (e) {
        $scope.$apply(function () {
          vm.fileCont = e.target.result
        })
      }

      reader.onerror = function (e) {
        alertSvc.alert('File could not be read! Code ' + e.target.error.code, 'danger')
      }

      reader.readAsText(vm.file.file)
    }
  }

  /**
   * Parse given csv/txt file
   */
  vm.parseFile = function () {
    // clear devices
    vm.devices = []

    var lines = vm.fileCont
      .replace(/^\s*[\r\n]/gm, '') // remove empty lines
      .replace(/^\s+|\s+$/gm, '') // remove spaces before and after each line
      .split(/\r\n|\r|\n/g) // split by line breaks

    // flag to indicate, is separator is line break
    var isNewline = vm.file.separator === '/n' ||
                    vm.file.separator === '/N' ||
                    vm.file.separator === '\\n' ||
                    vm.file.separator === '\\N'

    // flag to indicate, is separator is space symbol
    var isSpace = !vm.file.separator ||
                   vm.file.separator === '/s' ||
                   vm.file.separator === '\\s'

    // regular expression to split serials and mac addresses
    var re = isSpace || isNewline
      ? /\s+/
      : new RegExp('\\s*' + vm.file.separator.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&') + '\\s*')

    // step for 'for' cycle
    var step = isNewline
      ? 2
      : 1

    var first, second, splitted

    for (var i = 0; i < lines.length; i += step) {
      first = second = null

      if (isNewline) {
        first = lines[i]
        second = lines[i + 1]
      } else {
        splitted = lines[i].split(re)
        if (splitted.length >= 2) {
          first = splitted[0]
          second = splitted[1]
        }
      }

      if (first && second) {
        vm.devices.push({
          serialNumber: vm.file.serialFirst ? first : second,
          macAddress: vm.file.serialFirst ? second : first
        })
      }
    }

    // clear file input field and hide it with all options
    vm.file.file = null
    vm.uploadList = false
  }

  /**
   * Get pattern for security code
   * @returns {string}
   */
  vm.pattern = () =>
    !vm.autoSecurityCode
      ? '\\d{8}'
      : ''

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/devices.controller:AddDeviceCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.device._publicListUrl)
    }
  }
}
